import { gql } from '@apollo/client';

export const DASHBOARD_PROGRAMMES = gql`
  query DashboardProgrammes($input: FilterArgs) {
    dashboardProgrammes(input: $input) {
      id
      name
      fromDate
      toDate
      districts
      institutions
      beneficiaries
      beneficiariesReached
      sessionsCompleted
      schoolsReached
      serviceProviders {
        id
      }
      interventions {
        id
      }
    }
  }
`;
